import React from 'react'

export const Policy = React.lazy(() => import(/* webpackChunkName: "policy" */ '../modals/policy'))
